<template>
  <div>
    <nav
      class="navbar green-background"
      role="navigation"
      aria-label="main navigation"
    >
      <h1 class="page-header">{{ info.name }}</h1>

      <div class="navbar-end">
        <div class="navbar-item">
          <div class="buttons">
            <button
              v-if="admins.includes($store.state.user.email)"
              @click="settings_modal = true"
              class="button"
            >
              <strong>Settings</strong>
            </button>
            <button
              v-if="admins.includes($store.state.user.email)"
              @click="add_agent_modal = true"
              class="button"
            >
              <strong>Add Agent</strong>
            </button>
            <button
              v-if="admins.includes($store.state.user.email)"
              @click="list_agent_modal = true"
              class="button"
            >
              <strong>Agent List</strong>
            </button>
            <button
              v-if="admins.includes($store.state.user.email)"
              @click="scheduleGame.active = true"
              class="button"
            >
              <strong>Schedule Game</strong>
            </button>
            <a @click="logout()" class="button is-primary">
              <strong>Logout</strong>
            </a>
          </div>
        </div>
      </div>
    </nav>
    <div style="margin: 0px" class="tile is-ancestor">
      <div
        v-if="
          is_game_live &&
          is_game_live.id &&
          admins.includes($store.state.user.email)
        "
        class="tile is-vertical is-parent"
      >
        <div style="text-align: center" class="tile is-child box">
          <p style="display: flow-root" class="title">
            Tickets Polling
            <span class="tag is-warning">Live</span>
          </p>
          <div
            v-for="row in 10"
            :key="row"
            style="margin-bottom: 10px"
            class="columns is-centered is-gapless is-mobile"
          >
            <div
              v-for="column in 9"
              :key="row + '-' + column"
              style="border: 1px solid; margin: 2px"
              class="column has-background-light"
              :class="{
                'has-background-warning': liveData.includes(
                  column * 10 + row - 10
                ),
              }"
            >
              {{ column * 10 + row - 10 }}
            </div>
          </div>
        </div>
      </div>
      <div v-else class="tile is-vertical is-parent">
        <div class="tile is-child box">
          <p class="title">Player Ticket ({{ ticketCount }})</p>
          <section class="modal-card-body">
            <b-field
              :type="
                ticketType == 'Invalid Selection' ? 'is-danger' : 'is-success'
              "
              :message="ticketType"
              label="Ticket"
            >
              <b-input
                type="text"
                v-model.lazy="form.ticket"
                placeholder="Ticket"
                required
              ></b-input>
            </b-field>
            <b-field label="Name">
              <b-input
                type="text"
                v-model.lazy="form.name"
                placeholder="Player Name"
                required
              ></b-input>
            </b-field>
            <b-field label="Phone">
              <b-input
                type="text"
                v-model.lazy="form.phone"
                placeholder="Player Phone (optional)"
              ></b-input>
            </b-field>
            <div class="buttons">
              <button @click="assignTicket" class="button is-primary">
                ASSIGN TICKET</button
              ><button @click="unAssignTicket" class="button is-danger">
                UNASSIGN TICKET
              </button>
            </div>
          </section>
        </div>
      </div>
      <div
        v-if="admins.includes($store.state.user.email)"
        style="height: 470px"
        class="tile is-4 is-parent"
      >
        <div style="height: 100%; overflow: auto" class="tile is-child box">
          <p class="is-left title">Games</p>
          <div
            class="card has-border"
            @click="gameAction(game)"
            style="margin-top: 5px; padding: 8px; cursor: pointer"
            :key="game.id"
            v-for="game of games"
          >
            {{ buetifyTime(game.data().schedule.toDate()) }}
            <span
              :class="{
                tag: true,
                'is-warning': game.data().status == 'live',
                'is-info': game.data().status == 'schedule',
              }"
              >{{ game.data().status }}</span
            >
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="is_game_scheduled && cards"
      style="margin: 0px"
      class="tile is-ancestor"
    >
      <b-tabs
        position="is-centered"
        style="height: 100%; overflow: auto"
        class="block tile is-child box"
      >
        <b-tab-item label="All Tickets">
          <div
            class="has-background-primary"
            style="
              font-size: 12px;
              margin-left: 2px;
              margin-right: 2px;
              padding: 8px;
              border-radius: 12px;
              font-weight: bold;
            "
          >
            <div
              v-for="row in parseInt(is_game_scheduled.data().limit / 10)"
              :key="row"
              class="columns is-centered is-gapless is-mobile"
            >
              <div
                v-for="column in 10"
                :key="row + '-' + column"
                @click="showTicketInfo(cards[(row - 1) * 10 + column - 1])"
                class="column has-background-success"
                style="margin: 1px; border-radius: 5px; cursor: pointer"
                :class="{
                  'has-background-danger has-text-white': cards[
                    (row - 1) * 10 + column - 1
                  ]
                    ? cards[(row - 1) * 10 + column - 1].name
                    : false,
                  'has-background-warning': cards[(row - 1) * 10 + column - 1]
                    ? form.ticket
                        .split(',')
                        .some((t) => t == (row - 1) * 10 + column)
                    : false,
                }"
              >
                {{
                  cards[(row - 1) * 10 + column - 1]
                    ? (row - 1) * 10 + column
                    : ""
                }}
              </div>
            </div>
          </div>
        </b-tab-item>

        <b-tab-item label="Agent Summary">
          <div
            class="has-background-primary"
            style="
              font-size: 12px;
              margin-left: 2px;
              margin-right: 2px;
              text-align: left;
              padding: 8px;
              border-radius: 12px;
              font-weight: bold;
            "
          >
            <div
              class="card has-border"
              style="margin-top: 5px; padding: 8px; cursor: pointer"
              :key="agent.id"
              @click="showAgentInfo(agent)"
              v-for="agent of agents"
            >
              {{ agent.data().name }}({{ agent.data().email }})
              <span style="float: right; font-size: 15px">{{
                Array.isArray(cards)
                  ? cards.filter(
                      (card) => card.agent == agent.data().email.toLowerCase()
                    ).length
                  : 0
              }}</span>
            </div>
          </div>
        </b-tab-item>
      </b-tabs>
    </div>
    <b-modal
      :active.sync="scheduleGame.active"
      has-modal-card
      trap-focus
      :destroy-on-hide="false"
      aria-role="dialog"
      aria-modal
    >
      <ScheduleAsk @ScheduleGame="createGame"></ScheduleAsk>
    </b-modal>
    <b-modal
      :active.sync="add_agent_modal"
      has-modal-card
      trap-focus
      :destroy-on-hide="false"
      aria-role="dialog"
      aria-modal
    >
      <CreateAgent @AddAgent="AddAgent"></CreateAgent>
    </b-modal>
    <b-modal
      :active.sync="list_agent_modal"
      has-modal-card
      trap-focus
      :destroy-on-hide="false"
      aria-role="dialog"
      aria-modal
    >
      <AgentList
        ref="agentList"
        :del="admins.includes($store.state.user.email)"
        @DelAgent="DelAgent"
      ></AgentList>
    </b-modal>
    <b-modal
      :active.sync="agent_detail_modal"
      has-modal-card
      trap-focus
      :destroy-on-hide="false"
      aria-role="dialog"
      aria-modal
    >
      <AgentInfo :agent="selected_agent"></AgentInfo>
    </b-modal>
    <b-modal
      :active.sync="game_info_modal"
      has-modal-card
      trap-focus
      :destroy-on-hide="false"
      aria-role="dialog"
      aria-modal
    >
      <GameInfo
        @EditGame="editGame"
        @stopGame="stopGame"
        ref="selected_game"
      ></GameInfo>
    </b-modal>
    <b-modal
      :active.sync="settings_modal"
      has-modal-card
      trap-focus
      :destroy-on-hide="false"
      aria-role="dialog"
      aria-modal
    >
      <Settings @ChangeSettings="changeSettings"></Settings>
    </b-modal>
  </div>
</template>
<script>
import firebase from "firebase/app";
import "firebase/database";
import "firebase/firestore";
import "firebase/functions";

import { mapState } from "vuex";
import ScheduleAsk from "../components/ScheduleAsk";
import CreateAgent from "../components/CreateAgent";
import AgentList from "../components/AgentList.vue";
import AgentInfo from "../components/AgentInfo.vue";
import GameInfo from "../components/GameInfo.vue";
import Settings from "../components/Settings.vue";

export default {
  data() {
    return {
      games: [],
      admins: ["dorshidharma2@gmail.com", "ramanshekhawat75@gmail.com"],
      form: {
        name: "",
        phone: "",
        ticket: "",
      },
      selected_agent: {},
      add_agent_modal: false,
      is_game_scheduled: null,
      list_agent_modal: false,
      agent_detail_modal: false,
      game_info_modal: false,
      settings_modal: false,
      agents: [],
      is_game_live: {
        id: "",
        auto: false,
        time: 8000,
        intervalMethod: null,
      },
      liveData: [],
      scheduleGame: {
        active: false,
      },
    };
  },
  methods: {
    logout() {
      this.$store.dispatch("logout");
    },
    async fetchGames() {
      let gameSnap = await firebase
        .firestore()
        .collection("games")
        .orderBy("schedule", "desc")
        .get();
      this.games = gameSnap.docs;

      this.is_game_live = this.games.find(
        (game) => game.data().status == "live"
      );
      this.is_game_scheduled = this.games.find(
        (game) => game.data().status == "schedule"
      );
      this.is_game_scheduled = this.is_game_scheduled
        ? this.is_game_scheduled
        : this.games[0];
      if (this.is_game_live) {
        this.listenLiveGame();
      }
    },
    listenLiveGame() {
      this.is_game_scheduled = null;
      firebase
        .database()
        .ref("games")
        .child(this.is_game_live.id)
        .child("data")
        .child("polled")
        .on("child_added", (snap) => {
          this.liveData.push(snap.val());
        });
      firebase
        .database()
        .ref("games")
        .child(this.is_game_live.id)
        .child("winners")
        .on("child_added", (snap) => {
          this.$notify({
            group: "global",
            title: "Winner!",
            text: `${snap.val().length} won ${snap.key}`,
          });
        });
      firebase
        .firestore()
        .collection("games")
        .doc(this.is_game_live.id)
        .onSnapshot((doc) => {
          if (doc.data().status == "winner_declared") {
            this.is_game_live.auto = false;
            this.$buefy.dialog.alert({
              title: "Game Over!",
              ariaRole: "alertdialog",
              ariaModal: true,
              onConfirm: () => {
                window.location.href = "/";
              },
            });
          }
        });
    },
    buetifyTime(timestamp) {
      return (
        new Date(timestamp).toDateString() +
        " (" +
        new Date(timestamp).toLocaleTimeString() +
        ")"
      );
    },
    enableCard(card) {
      if (this.is_game_live) {
        if (this.liveData.includes(card)) return;
        firebase.functions().httpsCallable("poll_number")({
          number: card,
          gameId: this.is_game_live.id,
        });
      }
    },
    unAssignTicket() {
      if (
        this.admins.includes(this.$store.state.user.email) ||
        this.cards[this.form.ticket - 1].agent == this.$store.state.user.email
      ) {
        this.$buefy.dialog.confirm({
          message: "This may remove users from half & fullsheet.",
          onConfirm: () => {
            this.form.delete = true;
            this.assignTicket();
          },
        });
      } else {
        alert("can not un-assign ticket from another agent!");
      }
    },
    assignTicket() {
      if ((!this.form.delete && !this.form.name) || !this.form.ticket) {
        return;
      }
      let gameId = this.games.find((game) => game.data().status == "schedule");
      if (!gameId || !gameId.id) {
        return this.$buefy.dialog.alert({
          title: "Error",
          message:
            "We are not able to find any schedule game. please create one.",
          type: "is-danger",
          hasIcon: true,
          icon: "times-circle",
          iconPack: "fa",
          ariaRole: "alertdialog",
          ariaModal: true,
        });
      }
      const isAgent = this.agents.find(
        (agent) => agent.data().email == this.$store.state.user.email
      );
      if (isAgent && !this.form.delete) {
        if (
          this.cards.filter(
            (card) => card.agent == this.$store.state.user.email
          ).length >= isAgent.data().limit
        ) {
          return this.$buefy.dialog.alert({
            title: "Error",
            message: "You can not assign more tickets, your limit exhausted",
            type: "is-danger",
            hasIcon: true,
            icon: "times-circle",
            iconPack: "fa",
            ariaRole: "alertdialog",
            ariaModal: true,
          });
        }
      }
      firebase
        .functions()
        .httpsCallable("assign_tickets")({
          ...this.form,
          ticket: this.form.ticket.includes(",")
            ? this.form.ticket.split(",").map((ticket) => parseInt(ticket))
            : parseInt(this.form.ticket),
          gameId: gameId.id,
        })
        .then((data) => {
          this.form = { ticket: "", name: "" };
          this.$buefy.toast.open({
            message: data.data.message,
            type: "is-success",
          });
        })
        .catch((err) => {
          this.$buefy.dialog.alert({
            title: err.code,
            message: err.message,
            type: "is-danger",
            hasIcon: true,
            icon: "times-circle",
            iconPack: "fa",
            ariaRole: "alertdialog",
            ariaModal: true,
          });
        });
    },
    randomNum() {
      let fullItems = Array.from(Array(90), (_, i) => i + 1);
      let limtedArray = fullItems.filter((el) => !this.liveData.includes(el));
      return limtedArray[Math.floor(Math.random() * limtedArray.length)];
    },
    createGame(data) {
      data.time = data.time.getTime();
      firebase
        .functions()
        .httpsCallable("schedule")(data)
        .then((data) => {
          this.$buefy.toast.open(data.data.message);
          this.$store.dispatch("fetchStatus").then(() => {
            this.fetchGames();
            this.fetchAgentList();
          });
        })
        .catch((err) => {
          this.$buefy.dialog.alert({
            title: err.code,
            message: err.message,
            type: "is-danger",
            hasIcon: true,
            icon: "times-circle",
            iconPack: "fa",
            ariaRole: "alertdialog",
            ariaModal: true,
          });
        });
    },
    async fetchAgentList() {
      let agents = await firebase
        .firestore()
        .collection("agents")
        .orderBy("name", "asc")
        .get();
      this.agents = agents.docs;
    },
    AddAgent(data) {
      firebase
        .functions()
        .httpsCallable("add_agent")(data)
        .then(() => {
          this.$buefy.toast.open("agent created!");
          this.fetchAgentList();
        })
        .catch((err) => {
          this.$buefy.dialog.alert({
            title: err.code,
            message: err.message,
            type: "is-danger",
            hasIcon: true,
            icon: "times-circle",
            iconPack: "fa",
            ariaRole: "alertdialog",
            ariaModal: true,
          });
        });
    },
    DelAgent(uid) {
      firebase
        .functions()
        .httpsCallable("agent_delete")({ uid: uid })
        .then(() => {
          this.$buefy.toast.open("agent Deleted!");
          this.fetchAgentList();
          this.$refs.agentList.fetchAgentList();
        })
        .catch((err) => {
          this.$buefy.dialog.alert({
            title: err.code,
            message: err.message,
            type: "is-danger",
            hasIcon: true,
            icon: "times-circle",
            iconPack: "fa",
            ariaRole: "alertdialog",
            ariaModal: true,
          });
        });
    },
    makeLive(gameId) {
      this.$buefy.dialog.confirm({
        message: "Do you really want to start this game?",
        confirmText: "Start game",
        type: "is-primary",
        onConfirm: () => {
          firebase
            .functions()
            .httpsCallable("start")({ gameId: gameId })
            .then((v) => {
              this.fetchGames();
              this.liveData = [];
              this.$buefy.toast.open(v.data.message);
            })
            .catch((err) => {
              this.$buefy.dialog.alert({
                title: err.code,
                message: err.message,
                type: "is-danger",
                hasIcon: true,
                icon: "times-circle",
                iconPack: "fa",
                ariaRole: "alertdialog",
                ariaModal: true,
              });
            });
        },
      });
    },

    gameAction(game) {
      if (game.data().status == "live") {
        this.$buefy.dialog.confirm({
          title: "Warning",
          message: "Do you really want to stop this game?",
          confirmText: "Stop game",
          type: "is-danger",
          hasIcon: true,
          onConfirm: () => {
            this.stopGame(game.id);
          },
        });
      } else if (game.data().status == "schedule") {
        this.showGameInfo(game.id);
      } else if (game.data().status == "winner_declared") {
        this.$buefy.dialog.alert({
          title: "Winners",
          message: game.data()
            ? Object.keys(game.data().winners)
                .map((val) => {
                  return `<br/><h4>${val.replace("_", " ").toUpperCase()}</h4> 
                    <ol> ${game.data().winners[val].map((user) => {
                      return `<li>${user.name} ${user.number || ""} by agent (${
                        user.agent
                      })</li>`;
                    })} </ol>`;
                })
                .join()
            : "There is no winner found!",
          confirmText: "Cool!",
        });
      } else if (game.data().status == "stop") {
        this.showGameInfo(game.id);
      }
    },
    stopGame(gameId) {
      firebase
        .functions()
        .httpsCallable("stop")({ gameId: gameId })
        .then((v) => {
          this.fetchGames();
          this.$buefy.toast.open(v.data.message);
        })
        .catch((err) => {
          this.$buefy.dialog.alert({
            title: err.code,
            message: err.message,
            type: "is-danger",
            hasIcon: true,
            icon: "times-circle",
            iconPack: "fa",
            ariaRole: "alertdialog",
            ariaModal: true,
          });
        });
    },
    showTicketInfo(card) {
      if (card && card.name) {
        const sheet = this.sheets.find((sheet) =>
          sheet.includes(parseInt(card.number))
        );
        return this.$buefy.dialog.alert({
          title: `#${card.number} ${card.name}`,
          message: `Assigned By ${card.agent} <br/> ${
            sheet ? "SHEET: " + sheet.join(", ") : ""
          }`,
          confirmText: "OK",
        });
      }
      if (card) {
        this.selectTicket(card.number);
      }
    },
    showAgentInfo(agent) {
      this.selected_agent = agent.data();
      this.agent_detail_modal = true;
    },
    async showGameInfo(gameId) {
      this.game_info_modal = true;
      const info = await firebase.functions().httpsCallable("game_info")({
        gameId: gameId,
      });
      this.$refs.selected_game.setup({ id: gameId, ...info });
    },
    editGame(data) {
      firebase
        .functions()
        .httpsCallable("game_info_update")(data)
        .then((v) => {
          this.fetchGames();
          this.$buefy.toast.open(v.data.message);
        })
        .catch((err) => {
          this.$buefy.dialog.alert({
            title: err.code,
            message: err.message,
            type: "is-danger",
            hasIcon: true,
            icon: "times-circle",
            iconPack: "fa",
            ariaRole: "alertdialog",
            ariaModal: true,
          });
        });
    },
    changeSettings(data) {
      firebase
        .functions()
        .httpsCallable("settings_update")(data)
        .then((v) => {
          this.$store.dispatch("fetchInfo");
          this.$buefy.toast.open(v.data.message);
        })
        .catch((err) => {
          this.$buefy.dialog.alert({
            title: err.code,
            message: err.message,
            type: "is-danger",
            hasIcon: true,
            icon: "times-circle",
            iconPack: "fa",
            ariaRole: "alertdialog",
            ariaModal: true,
          });
        });
    },
    selectTicket(number) {
      if (!this.form.ticket) {
        return (this.form.ticket = number);
      }
      if (!this.form.ticket.split(",").some((t) => t == number)) {
        const ts = this.form.ticket.split(",");
        ts.push(number);
        this.form.ticket = ts.join(",");
      }
    },
  },
  computed: {
    ...mapState(["cards", "sheets", "info", "currentGame"]),
    ticketCount() {
      if (this.currentGame.status == "winner_declared") {
        return "Not Available";
      }
      if (this.cards && Array.isArray(this.cards)) {
        return `${
          this.cards.filter((card) => {
            return card.name;
          }).length
        }/${this.cards.length}`;
      } else {
        return "Not Available";
      }
    },
    ticketType() {
      if (!this.form.ticket) {
        return "";
      }
      const count = this.form.ticket.split(",").length;
      if (count === 1) {
        return "Single Ticket";
      } else if (count === 3) {
        return "Half Sheet";
      } else if (count === 6) {
        return "Full Sheet";
      }
      return "Invalid Selection";
    },
  },
  created() {
    this.fetchGames();
    this.fetchAgentList();
  },
  components: {
    ScheduleAsk,
    CreateAgent,
    AgentList,
    AgentInfo,
    GameInfo,
    Settings,
  },
};
</script>
    